import type { ExtendedComboBoxOptions } from '../types/modules/kendo';

window.kendoWindowOptions = {
    draggable: true,
    scrollable: true,
    visible: false,
    animation: false,
    resizable: true
};

function setControlData(control: kendo.ui.ComboBox, dataFunc: Function, action: string) {
    const read = control.dataSource.options.transport?.read as kendo.data.DataSourceTransportRead;
    read.data = dataFunc;
    if (action) read.url = action;
}

/**
 * Получение значения из контрола для ДТО; здсь же логика для селектов с выбором только "Да" и "Нет"
 * @param obj Контрол
 * */
function filterValue(obj: any) {
    // Защита от undefined
    if (!obj) return null;

    switch (obj.ns) {
        case '.kendoMultiSelect':
            if (obj.value().includes(-1)) {
                return [];
            }
            else if (obj.dataSource._data.length === 3 &&
                obj.dataSource._data[1].Name === 'Да' &&
                obj.dataSource._data[2].Name === 'Нет') {
                return (obj.value().includes(0) && obj.value().includes(1) || obj.value().length === 0) ? null : obj.value().includes(1);
            }
            else {
                return obj.value();
            }
        case '.kendoDataPicker':
            return obj.value() !== null ? obj.value().toLocaleDateString() : '';
        case '.kendoComboBox':
            if (obj.value() === '-1') {
                return null;
            }
            else if (obj.dataItems().length === 3 &&
                obj.dataItems()[1].Text === 'Да' &&
                obj.dataItems()[2].Text === 'Нет') {
                return obj.selectedIndex === 1;
            }
            else {
                return obj.value();
            }
        default:
            return obj.value();
    }
}

function autoInitControls() {
    let controlName: any;
    $('[data-role]').each((_, v) => {
        var elem = $(v);
        controlName = elem.attr('id');
        if (controlName && controlName.endsWith('_Id') && controlName[0].toUpperCase === controlName[0]) { //ComboBoxFor etc
            controlName[0] = controlName[0].toLowerCase();
            controlName = controlName.substring(0, controlName.length() - 3);
        }
        var kendoTypeName = Object.getOwnPropertyNames(elem.data())
            .find((item: string) => item.startsWith('kendo') && item !== 'kendoPopup' && item !== 'kendoStaticList');
        if (!controlName || !kendoTypeName)
            return;

        window[controlName] = elem.data(kendoTypeName);
    });
    $('textarea:not(.k-content)').each((_, v) => {
        var elem = $(v);
        controlName = elem.attr('id');
        if (controlName) {
            window[controlName] = elem as any;
        }
    });
    $('.k-checkbox').each((_, v) => {
        var elem = $(v);
        controlName = elem.attr('id');
        if (controlName) {
            window[controlName] = elem as any;
        }
    });
}

function initConfigureComboBox() {
    $('[data-role=combobox]').each((_, element) => {
        configureComboBoxOpening(element);
    });
}

function configureComboBoxOpening(element: HTMLElement) {
    const control = $(element).data('kendoComboBox');
    const $input = control?.input;

    if (element.hasAttribute('data-set-focus-event')) return;

    if ($input && $input.attr('aria-disabled') !== 'true') {
        $input.on('click', () => {
            (control.options as ExtendedComboBoxOptions).enabled && control.open();
        });

        element.setAttribute('data-set-focus-event', '');
    }

    $input?.attr('autocomplete', 'off');
}

function initInputFocus() {
    const $allInputs = $('input:not(:has(+ [data-role=numerictextbox]))');

    $allInputs.on('focus', ({ currentTarget }) => {
        const $currentInput = $(currentTarget);
        const role = $currentInput.data().role;
        if (role === 'combobox' || role === 'multiselect') return;
        queueMicrotask(() => $currentInput.trigger('select'));
    });
}

function setControlsSettings() {
    const PHONE_NUMBER_INVALID_CHARS_REGEX = /[^0-9()\s\-+]/g;
    const STANDARD_TIME_REGEX = /^(?:[01]\d|2[0-3]):?[0-5]\d$|^(?:[01]\d|2[0-3])[0-5]\d$/;
    const WORKLOAD_TIME_REGEX = /^(?:\d{2}|100):[0-5]\d$/;
    const filesGridDiv = $('#grFiles');

    if (filesGridDiv.length === 1) {
        filesGridDiv.on('mousedown', 'tr[role="row"]', window.gridRowRightClick);
    }

    initConfigureComboBox();

    initializeDateWidgets('datepicker', 'kendoDatePicker');
    initializeDateWidgets('datetimepicker', 'kendoDateTimePicker');

    $('[data-role=timepicker]').each((_, element) => {
        const widget = $(element).data('kendoTimePicker');
        const $input = widget?.element;

        if (element.hasAttribute('data-set-focus-event')
            || widget?.element.attr('aria-disabled') === 'true') {
            return;
        }

        if ($input) {
            window.validateTimeInput($input, STANDARD_TIME_REGEX);
            $input.on('click', () => widget.open());
            element.setAttribute('data-set-focus-event', '');
        }
    });

    initInputFocus();

    $('[data-validator="time-cost"]').each((_, elementWrapper) => {
        const $inputs = $(elementWrapper).find('input[data-role="combobox"]');
        const widget = $inputs.data('kendoComboBox');
        const $input = widget?.element;

        if ($input) {
            if ($input.data('set-validator')) {
                return;
            }
            window.validateTimeInput($input, WORKLOAD_TIME_REGEX);
            $input.data('set-validator', true);
        }
    });

    $('[data-intl-tel-input-id]').each((_, input: HTMLInputElement) => {
        if (input?.getAttribute('aria-disabled') === 'true') return;
        const iti = window.getIntlTelInputInstance(input);
        input.addEventListener('change', window.validatePhoneInput.bind(input, iti));
    });

    $('[data-validator="phone"]').each((_, input: HTMLInputElement) => {
        window.validatePhoneTextBox($(input), PHONE_NUMBER_INVALID_CHARS_REGEX);
    });
}

function toggleVisibleWindow(instance: kendo.ui.Window) {
    instance.options.visible ? instance.close() : instance.open();
}

function initializeDateWidgets(role: string, widgetType: string) {
    $(`[data-role=${role}]`).each((_, element) => {
        const widget = $(element).data(widgetType);
        const $input = widget?.element;

        if (element.hasAttribute('data-set-focus-event')) return;

        if ($input && $input.attr('aria-selected') !== 'true') {
            window.validateDateInput($input);
            $input.on('click', widget.open.bind(widget));
            element.setAttribute('data-set-focus-event', '');
        }
    });
}

window.setControlsSettings = setControlsSettings;
window.autoInitControls = autoInitControls;
window.filterValue = filterValue;
window.initConfigureComboBox = initConfigureComboBox;
window.configureComboBoxOpening = configureComboBoxOpening;
window.initInputFocus = initInputFocus;
window.setControlData = setControlData;
window.toggleVisibleWindow = toggleVisibleWindow;
window.initializeDateWidgets = initializeDateWidgets;